import { apiCall, filterParams } from '../helpers/axios';

class PaymentService {

	static delete(paymentId) {
		return apiCall().delete(`/payments/${paymentId}`)
			.then(response => response.data);
	}

	static create(params) {
		return apiCall().post(`/payments`, params)
			.then(response => response.data);
	}
}

export default PaymentService


// WEBPACK FOOTER //
// ./src/services/payment-service.js